import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'help_center-open_quick_modal_event-click';

/**
 * Emits Action Type on click event for the quick action button
 */
export function trackHelpCenterOpenQuickModalEventClick(
  ACTION_TYPE: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { ACTION_TYPE },
  });
}
